export default "__VITE_ASSET__lewFcANl__"